// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__17XDq","inner":"Form_inner__2fw-D","range":"Form_range__mqT48","name":"Form_name__1Zvh6","actions":"Form_actions__cmBY6"};